import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Copy01Icon } from '@/components/ui/icon/glyphs';
export function FundingAddress(t0) {
  const $ = _c(12);
  const {
    address,
    onCopy
  } = t0;
  const t = useTranslations("onramp");
  let t1;
  if ($[0] !== address) {
    t1 = <code className="min-w-0 flex-1 break-all font-mono text-caption">{address}</code>;
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("manual_transfer_copy");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onCopy) {
    t3 = () => {
      onCopy();
    };
    $[4] = onCopy;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <AnimatedButton variant="tertiary" prefix={Copy01Icon} aria-label={t2} className="shrink-0 touch-target" onClick={t3} />;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="flex items-center gap-3 rounded-control bg-background-tertiary p-2 pl-3">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}